<template>
  <div class="banners-block-cms">
    <div class="container">
      <template v-if="!validBanners.length">
        <div class="blocks loading">
          <div class="blocks__element flex hover-shadow-4 element-0" />
          <div class="blocks__element flex hover-shadow-4 element-1" />
          <div class="blocks__element flex hover-shadow-4 element-2" />
          <div class="blocks__element flex hover-shadow-4 element-3" />
          <div class="blocks__element flex hover-shadow-4 element-4" />
        </div>
      </template>
      <div v-else class="blocks">
        <banner-tile
          v-for="(banner, index) of validBanners"
          :key="index"
          :banner="banner"
          class="blocks__element flex hover-shadow-4"
          :class="'element-' + index"
          :style="{
            backgroundColor: '#' + banner.hex
          }"
          @click="clickMidBanner(banner)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BannerTile from './BannerTile'

export default {
  props: {
    validBanners: {
      type: Array,
      required: true
    }
  },
  components: {
    BannerTile
  },
  methods: {
    clickMidBanner (banner) {
      this.$store.commit('ui/CLICK_BANNER', banner)
    }
  }
}
</script>

<style lang="scss" scoped>
.banners-block-cms {
  background-color: white;
  @media (max-width: 767px) {
    background-color: unset;
  }
  .blocks {
    @media (max-width: 767px) {
      grid-template-rows: 450px 450px 450px 450px 450px;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    &.loading {
      .blocks__element {
        background-color: #F2F3F4;
      }
    }
    padding-top: 80px;
    padding-bottom: 80px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 350px 350px;
    gap: 20px;
    &__element {
      border-radius: 15px;
      background-color: #ffedcd;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center bottom;
    }

    .blocks__element {
      @media (max-width: 767px) {
        grid-column-start: auto !important;
        grid-column-end: span 7 !important;
        grid-row-end: auto !important;
      }
    }
    .element-0 {
      grid-column-end: span 2;
    }
    .element-1 {
      grid-column-end: span 3;
    }
    .element-2 {
      grid-column-start: 6;
      grid-column-end: span 2;
      grid-row-end: span 2;
    }
    .element-3 {
      grid-column-end: span 3;
    }
    .element-4 {
      grid-column-end: span 2;
    }
  }
}
</style>
